import type { PeriodState } from './period-state.enum';
import type { PagedRequestDto } from '../pagination/models';

export interface PeriodDto {
  id: number;
  name: string;
  dateFrom?: string;
  dateTo?: string;
  postingDate?: string;
  state?: PeriodState;
  serviceTypeId: number;
  serviceTypeName?: string;
}

export interface PeriodInputDto {
  id: number;
  name: string;
  dateFrom?: string;
  dateTo?: string;
  postingDate?: string;
  state?: PeriodState;
  serviceTypeId: number;
}

export interface PeriodPagedRequestDto extends PagedRequestDto {
  name?: string;
  dateFrom?: string;
  dateTo?: string;
  serviceTypeId?: number;
  state?: PeriodState;
}
